import { Switch } from '@mui/material';

import styled from 'styled-components';

export const StyledSwitch = styled(Switch)`
  width: 28px !important;
  height: 16px !important;
  padding: 0 !important;
  display: flex !important;

  &:active {
    .MuiSwitch-thumb {
      width: 15px;
    }
    .MuiSwitch-switchBase.Mui-checked {
      transform: translateX(9px);
    }
  }

  .MuiSwitch-switchBase {
    padding: 2px !important;

    &.Mui-checked {
      transform: translateX(12px) !important;
      color: #fff !important;

      & + .MuiSwitch-track {
        opacity: 1 !important;
        background-color: ${props =>
          props.theme.custom.palette.primaryOrange} !important;
      }
    }
  }

  .MuiSwitch-thumb {
    box-shadow: 0 2px 4px 0 rgba(0, 35, 11, 0.2) !important;
    width: 12px !important;
    height: 12px !important;
    border-radius: 6px !important;
    transition: width 200ms !important;
  }

  .MuiSwitch-track {
    border-radius: 8px !important;
    opacity: 1 !important;
    background-color: rgba(0, 0, 0, 0.25) !important;
    box-sizing: border-box;
  }
`;
